import BigNumber from 'bignumber.js';
import { useGetContractByUserWeb3 } from './use-contract';

import ERC20_ABI from '@/contracts/erc20.json';
import { useCallback, useEffect, useState } from 'react';
import { useAccount, useChainId } from 'wagmi';
import { useEthersProvider } from './useEthersProvider';
import user from '@/stores/user';
import GOAT_OFT_ABI from '@/contracts/goatLayerzeroAdaper/abi.json';

// token = '' query user balance

export default function useTokenBalance(
    token: string,
    account?: string,
    params = {
        intervalTime: 10000,
        isOft: false,
    },
) {
    const [balance, setBalance] = useState(new BigNumber(0));

    const [loadingOnce, setLoadingOnce] = useState(false);
    const { address } = useAccount();
    const chainId = useChainId();
    const provider = useEthersProvider({ chainId });
    const fetchAddress = account || address;
    const [loading, setLoading] = useState(false);
    const getContract = useGetContractByUserWeb3();

    const getBalance = useCallback(async () => {
        if (!fetchAddress || token == undefined) {
            setLoadingOnce(true);
            return;
        }
        setLoading(true);

        try {
            if (token === '') {
                // Query native token (ETH/METIS) balance
                if (!provider) return;
                const nativeBalance = await provider.getBalance(fetchAddress);
                setBalance(
                    new BigNumber(nativeBalance.toString()).shiftedBy(-18),
                );
            } else {
                const tokenContract = params.isOft
                    ? await getContract(token, GOAT_OFT_ABI, false)
                    : await getContract(token, ERC20_ABI, false);

                if (!tokenContract) {
                    console.error(
                        `tokenContract is null, token: ${token}, account: ${fetchAddress} `,
                    );
                    setLoading(false);
                    return;
                }
                const balance = await tokenContract.balanceOf(fetchAddress);
                const decimals = await tokenContract.decimals();

                if (balance && decimals) {
                    setBalance(
                        new BigNumber(balance.toString()).shiftedBy(
                            -Number(decimals),
                        ),
                    );
                }
            }
        } catch (e) {
            setBalance(new BigNumber(0));
            console.error(
                `useTokenBalance error, token: ${token}, account: ${fetchAddress} `,
            );
            console.error(e);
        }
        setLoading(false);

        setLoadingOnce(true);
    }, [fetchAddress, token, provider, params.isOft]);

    useEffect(() => {
        getBalance();
        const interval = setInterval(() => {
            getBalance();
        }, params.intervalTime || 10000);

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [getBalance, user.chainId, params.intervalTime]);
    useEffect(() => {
        if (fetchAddress) {
            setBalance(new BigNumber(0));
            setLoadingOnce(false);
        }
    }, [fetchAddress]);

    return {
        balance,
        getBalance,
        loadingOnce,
        loading,
    };
}
